import React, { useCallback, useEffect, useMemo, useState } from 'react'

// Api
import { getContractInfo } from 'api/contract'

// Use
import useMounted from 'use/mounted'
import { useSelector } from 'react-redux'

// Models
import ContractModel from 'models/Contract'

// Components
import Header from 'ui/Header'
import Navbar from 'ui/Navbar'
import Container from 'ui/Container'
import Row from 'ui/Row'
import Col from 'ui/Col'
import Footer from 'ui/Footer'
import Space from 'ui/Space'
import Text from 'ui/Text'
import Skeleton from 'ui/Skeleton'
import LessorInfo from 'ui/LessorInfo'
import LatestAnnouncements from 'components/Announcement/LatestAnnouncements'
import ContractFilter from 'components/MyAccount/ContractFilter'
import ContractInfo from 'components/MyAccount/ContractInfo'
import ContractSummary from 'components/Payment/ContractSummary'
import PaymentTracker from 'components/Payment/PaymentTracker'

// Assets
import ImageProof from 'assets/images/proof.png'

export default function PageMyAccount() {
  const isMounted = useMounted()
  const filters = useSelector((state) => state.dashboard.filters)
  const [loading, setLoading] = useState(false)

  const [contract, setContract] = useState(new ContractModel())

  const isContractExisted = useMemo(() => contract && contract.id, [contract])

  const getContract = useCallback(async () => {
    setContract(new ContractModel())

    if (filters.companyCode && filters.vendorCode && filters.contractNumber) {
      try {
        setLoading(true)

        const data = await getContractInfo({
          companyCode: filters.companyCode,
          vendorCode: filters.vendorCode,
          contractNumber: filters.contractNumber,
        })

        if (isMounted.current) {
          setContract(data)
        }
      } catch (error) {
        //
      } finally {
        if (isMounted.current) {
          setLoading(false)
        }
      }
    }
  }, [
    filters.companyCode,
    filters.contractNumber,
    filters.vendorCode,
    isMounted,
  ])

  useEffect(() => {
    getContract()
  }, [getContract])

  return (
    <>
      <Header />
      <Navbar />
      <Container>
        <Row>
          <Col xs={12} md={10}>
            <LessorInfo
              lessorName={filters.lessorName}
              companyId={filters.companyId}
              vendorId={filters.vendorId}
            />
          </Col>
        </Row>

        <Row>
          <Col xs={12} md={3} style={{ marginBottom: '20px' }}>
            <Col xs={12} md={11}>
              <LatestAnnouncements />
            </Col>
          </Col>

          <Col xs={12} md={9}>
            <ContractFilter />

            <Skeleton loading={loading}>
              {isContractExisted ? (
                <>
                  <ContractInfo
                    contract={contract}
                    lessorId={filters.lessorId}
                    vendorId={filters.vendorId}
                    companyId={filters.companyId}
                  />
                  <ContractSummary
                    contract={contract}
                    companyCode={contract.companyCode}
                    vendorCode={contract.vendorCode}
                    contractNumber={contract.contractNumber}
                  />
                  <PaymentTracker
                    companyCode={contract.companyCode}
                    vendorCode={contract.vendorCode}
                    contractNumber={contract.contractNumber}
                    lessorId={filters.lessorId}
                    vendorId={filters.vendorId}
                    companyId={filters.companyId}
                  />
                </>
              ) : (
                <Space
                  className="d-flex flex-column"
                  style={{
                    marginTop: '50px',
                  }}
                >
                  <Text color="#a3a3a3">No contract to view has been</Text>
                  <Text color="#a3a3a3" paddingBottom={20}>
                    selected yet
                  </Text>
                  <img src={ImageProof} width="200px" />
                </Space>
              )}
            </Skeleton>
          </Col>
        </Row>
      </Container>
      <Footer />
    </>
  )
}
